import React from 'react';
import { Download } from 'lucide-react';
import { Button } from '@heroui/react';
import { FileMetadata } from '@/services/apis/files';

interface PdfStepProps {
  content?: {
    pdf?: FileMetadata;
    text?: string;
  };
  title?: string;
}

const PdfStep: React.FC<PdfStepProps> = ({ content, title }) => {
  // Handle both FileMetadata object and string URL
  const pdfUrl = typeof content?.pdf === 'string' ? content.pdf : content?.pdf?.url;

  return (
    <div className="space-y-4">
      {pdfUrl && (
        <div className="relative w-full h-[600px] bg-gray-100 dark:bg-gray-800 rounded-lg overflow-hidden border border-gray-300 dark:border-gray-700">
          <iframe src={pdfUrl} className="w-full h-full" frameBorder="0" title={title} />
        </div>
      )}
      {pdfUrl && (
        <div className="text-center">
          <Button
            as="a"
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            variant="flat"
            startContent={<Download className="w-4 h-4" />}
          >
            Open PDF in new tab
          </Button>
        </div>
      )}
    </div>
  );
};

export default PdfStep;
